import $ from 'jquery';

import {
    maybeParseInt,
    calculatorLoadStart,
    calculatorLoadError
} from "./calculator-utils";
import calculatorDisplayDepositResults from "./calculator-handle-deposit-results";
import { getSuburbList, getPostCode } from "./calculator-suburb-list";

export default function () {
    //const NET_MONTHLY_INCOME = 13000; // Default amount to send
    calculatorLoadStart();

    $('.no-low-deposit').removeClass('no-low-deposit');
    $('.no-graduate').removeClass('no-graduate');
    $('.no-shared-equity').removeClass('no-shared-equity')
    $('.advantage_text').hide();
    let minPurchasePrice = parseFloat($('#validation-data').attr('data-property-min'));
    let maxPurchasePrice = parseFloat($('#validation-data').attr('data-property-max'));

    window.results = new Array(); // reset any potential other results
    let suburb = ($("#deposit_suburb").val() != "") ? $("#deposit_suburb").val() : "ADELAIDE";
    $("#deposit_suburb").val(suburb)

    let data = {
        "GivenPurchasePrice": maybeParseInt($("#deposit_property_price").val()).toString(),
        "IsFirstHomeBuyer": ($('input[name="deposit_first_home_buyer"]:checked').val() == "yes") ? "true" : "false",
        "Postcode": getPostCode(suburb),
        "Purpose": ($('input[name="deposit_build_or_buy"]:checked').val() == "buy") ? "BuyHome" : "BuyLandAndBuild",
    };

    if (parseFloat(data.GivenPurchasePrice) >= maxPurchasePrice) {
        calculatorLoadError('No result(s) found for the provided parameter(s)');
        return;
    }
    if (parseFloat(data.GivenPurchasePrice) <= minPurchasePrice) {
        calculatorLoadError(`Please enter a property purchase price greater than $${minPurchasePrice}, without symbols and spaces.`);
        return;
    }
    /*let suburbs = getSuburbList(false);
    if (suburbs[suburb.toUpperCase()] === undefined) {
        calculatorLoadError("Locality not found")
        return;
    }*/

    let url = window.location.origin + '/api/calculator/hmdin';
    console.log("posting to " + url, data);

    $.ajax(
        {
            url: url,
            type: "GET",
            data: data,
            contentType: "application/json",
            dataType: "json",
            success: function (result) {
                /*let hasError = false;
                let errorText = '';
                  result.scenarios.forEach(function (sc) {
                    if (sc.status == 'Fail') {
                        console.log(result);
                        hasError = true;
                        errorText = 'Error retrieving the data'//sc.errors[0].description
                    }
                })
                if (hasError) {
                    calculatorLoadError(errorText);
                } else if (result.status == 'Fail') {
                    if (result.errors.length > 0) {
                        calculatorLoadError(result.errors[0].description);
                    } else {
                        calculatorLoadError('Error retrieving the data');
                    }
                } else {*/
                    // result = { "status": "Success", "errors": [], "scenarios": [{ "scenarioName": "LowDepositAdvantage", "primaryProductName": "LowDeposit", "estimatedTerms": "213", "homeDeposit": -13500, "totalFees": 29750.5, "totalCharges": 0, "totalFeesAndCharges": 29750.5, "feesAndChargesBreakdown": [{ "name": "CONVEYANCER", "value": 2500 }, { "name": "ESTABLISHMENTFEE", "value": 845 }, { "name": "SETTLEMENTFEE", "value": 200 }, { "name": "DISBURSEMENTADMINFEE", "value": 0 }, { "name": "SEARCHFEE", "value": 32 }, { "name": "MORTGAGEREGISTRATIONFEE", "value": 179 }, { "name": "SEARCHADMINISTRATIONFEE", "value": 18 }, { "name": "TEST2", "value": 0 }, { "name": "VALUATIONFEE", "value": 220 }, { "name": "Stamp Duty on Conveyance", "value": 21330 }, { "name": "Registration of Transfer", "value": 4426.5 }], "assistanceLoanEligibility": false, "minimumDepositAmount": 0, "status": "Success", "errors": [] }, { "scenarioName": "GraduateAdvantage", "primaryProductName": "Graduate", "estimatedTerms": "276", "homeDeposit": -9000, "totalFees": 29750.5, "totalCharges": 0, "totalFeesAndCharges": 29750.5, "feesAndChargesBreakdown": [{ "name": "CONVEYANCER", "value": 2500 }, { "name": "ESTABLISHMENTFEE", "value": 845 }, { "name": "SETTLEMENTFEE", "value": 200 }, { "name": "DISBURSEMENTADMINFEE", "value": 0 }, { "name": "SEARCHFEE", "value": 32 }, { "name": "MORTGAGEREGISTRATIONFEE", "value": 179 }, { "name": "SEARCHADMINISTRATIONFEE", "value": 18 }, { "name": "TEST2", "value": 0 }, { "name": "VALUATIONFEE", "value": 220 }, { "name": "Stamp Duty on Conveyance", "value": 21330 }, { "name": "Registration of Transfer", "value": 4426.5 }], "assistanceLoanEligibility": false, "minimumDepositAmount": 0, "status": "Success", "errors": [] }, { "scenarioName": "StandardAdvantage", "primaryProductName": "Standard", "estimatedTerms": "276", "homeDeposit": -22500, "totalFees": 29750.5, "totalCharges": 0, "totalFeesAndCharges": 29750.5, "feesAndChargesBreakdown": [{ "name": "CONVEYANCER", "value": 2500 }, { "name": "ESTABLISHMENTFEE", "value": 845 }, { "name": "SETTLEMENTFEE", "value": 200 }, { "name": "DISBURSEMENTADMINFEE", "value": 0 }, { "name": "SEARCHFEE", "value": 32 }, { "name": "MORTGAGEREGISTRATIONFEE", "value": 179 }, { "name": "SEARCHADMINISTRATIONFEE", "value": 18 }, { "name": "TEST2", "value": 0 }, { "name": "VALUATIONFEE", "value": 220 }, { "name": "Stamp Duty on Conveyance", "value": 21330 }, { "name": "Registration of Transfer", "value": 4426.5 }], "assistanceLoanEligibility": false, "minimumDepositAmount": 0, "status": "Success", "errors": [] }] }
                    calculatorDisplayDepositResults(result)
                //}
            },
            error: function (jqXHR, textStatus, errorThrown) {
                calculatorLoadError()
            }
        });
};
